// Parâmetros Financeiros Padrão
export const PARAMETROS_SIMULACAO = {
    PRAZO: 420,
    JUROS_EFETIVO: 7,
    SISTEMA_AMORTIZACAO: 1,  //1-SAC  2-PRICE
    MARCA_MRV: 1,
    MARCA_SENSIA: 2,
    EM_CASH: false,
    ID_PROPOSTA_BASE: '00000000-0000-0000-0000-000000000000'
};

// Tooltips compartilhados
export const CARTA_DE_CREDITO_TOOLTIP = 'Não pode ser utilizada em conjunto com EmCash, Pagadoria, Negociação Especial ou empreendimentos com loteadora.';

// Limites de Tabelas
export const LIMITES = {
    SINAIS: 5,
    INTERMEDIARIAS: 3,
    INTERMEDIARIAS_FLEX: 5,
    COMPRADORES: 10,
    PARCELAS_MENSAIS : 99
};

// Mapeamento para exibição de tipos de parcela
export const TIPOS_PARCELA = {
    0: 'NA',
    1: 'Intermediaria',
    2: 'Mensal',
    3: 'Sinal',
    4: 'Bom pagador',
    5: 'Vazia',
    6: 'Fgts',
    7: 'Carta de Crédito'
};

// Mapeamento para exibição de sinais
export const TIPOS_SINAL = {
    1: 'ATO',
    2: 'E2',
    3: 'E3'
};

// Função helper para obter o tipo de parcela formatado
export const getTipoParcela = (parcela, index, parcelas) => {
    if (parcela.tipo === 3) {
        if (parcela.atoComplementar) {
            return 'Ato Complementar (Carta de Crédito)';
        }
        // Conta quantos sinais apareceram antes desta parcela
        const sinalIndex = parcelas.slice(0, index).filter(p => p.tipo === 3).length + 1;
        return TIPOS_SINAL[sinalIndex] || 'Sinal';
    }
    return TIPOS_PARCELA[parcela.tipo] || 'Desconhecido';
};

// Opções para Dropdowns
export const OPTIONS = {
    // Rating de crédito
    RATING: [
        { value: 'A', label: 'A' },
        { value: 'B', label: 'B' },
        { value: 'C', label: 'C' },
        { value: 'D', label: 'D' },
        { value: 'E', label: 'E' },
        { value: 'F', label: 'F' },
        { value: 'G', label: 'G' },
        { value: 'H', label: 'H' }
    ],

    // Planos disponíveis
    PLANO: [
        { value: false, label: 'Plano Fácil' },
        { value: true, label: 'Plano Padrão' }
    ],

    // Tipos de simulação
    TIPO_SIMULACAO: [
        { value: '1', label: 'Manual - sem crédito aprovado', disabled: false },
        { value: '2', label: 'Utilizar dados Jornada com crédito aprovado (em breve)', disabled: true },
        { value: '3', label: 'Utilizar Simulador Caixa (em breve)', disabled: true }
    ],

    // Meses do ano
    MESES: [
        { value: 1, label: 'Janeiro' },
        { value: 2, label: 'Fevereiro' },
        { value: 3, label: 'Março' },
        { value: 4, label: 'Abril' },
        { value: 5, label: 'Maio' },
        { value: 6, label: 'Junho' },
        { value: 7, label: 'Julho' },
        { value: 8, label: 'Agosto' },
        { value: 9, label: 'Setembro' },
        { value: 10, label: 'Outubro' },
        { value: 11, label: 'Novembro' },
        { value: 12, label: 'Dezembro' }
    ]
};


export const FAIXA_COMERCIAL = {
    NA: 0,
    FAIXA1E5: 1,
    FAIXA2E3: 2,
    SBPE: 3,
    PROCOTISTA: 4,
    FAIXA3: 5,
    FAIXA4: 6
};

export const ENQUADRAMENTOS = [
    { id: "dced4119-2e37-40e2-bfe8-c715c18646b3", nome: "CCFGTS/PMCMV 1.5", faixa: FAIXA_COMERCIAL.FAIXA1E5 },
    { id: "16a7b596-0501-4b36-829c-9d2de406f8f2", nome: "CCFGTS/PMCMV 2", faixa: FAIXA_COMERCIAL.FAIXA2E3 },
    { id: "6f906d6c-a2d1-4aea-8569-c13ebf4ad295", nome: "CCFGTS/PMCMV 1", faixa: FAIXA_COMERCIAL.FAIXA2E3 },
    { id: "b7a53665-0c58-4809-bbd9-cfd3b9edccd9", nome: "CCFGTS", faixa: FAIXA_COMERCIAL.FAIXA2E3 },
    { id: "bcacd8be-b0a7-4e62-bb3d-f724e4a65a72", nome: "SBPE - TR", faixa: FAIXA_COMERCIAL.SBPE },
    { id: "a1666f60-0f48-4979-a36c-9569d9a4b4d0", nome: "SBPE - IPCA", faixa: FAIXA_COMERCIAL.SBPE },
    { id: "eecb64b4-03e0-4da1-8d52-7208bbd0908b", nome: "SBPE - Poupança CEF", faixa: FAIXA_COMERCIAL.SBPE },
    { id: "f0db2ebc-d14f-4f7c-b639-8eb2587598e8", nome: "SBPE - Pré-Fixada", faixa: FAIXA_COMERCIAL.SBPE },
    { id: "9e3fe993-6e4e-4628-b8be-8c54c8b93ff5", nome: "PRO-COTISTA", faixa: FAIXA_COMERCIAL.PROCOTISTA },
    { id: "02a502f6-bf29-4383-bda7-63407dc9c7c3", nome: "CCFGTS/PMCMV 3", faixa: FAIXA_COMERCIAL.FAIXA3 },
    { id: "6c7aed40-7500-41d6-9225-8fd348e6efe9", nome: "PMCMV 4", faixa: FAIXA_COMERCIAL.FAIXA4 },
]

// --- SIMULADOR FLEX --- //

export const ALL_PLANOS = {
  '0': 'NA',
  'AVista': 'À Vista',
  'Fixo12': 'Flex Fixo (12 Meses)',
  'Fixo18': 'Flex Fixo (18 Meses)',
  'PrazoObra': 'Prazo de Obra',
  'PosObra': 'Pós Obra',
  'FinanciamentoBancario': 'Financiamento Bancário'
};

export const TIPO_FLUXO = {
  '0': 'NA',
  '1': '100/0',
  '2': '20/80',
  '3': '30/70',
  '4': "40/60",
  '5': "50/50",
  '6': "35/65",
  '7': "45/55"
}

export const TIPO_CORRECAO = {
  '0': 'NA',
  'SemCorrecao': 'Sem Correção',
  'IPCA': 'IPCA',
  'IPCA_075': 'IPCA + 0,75% / IPCA + 0,75%',
  'IPCA_085': 'IPCA + 0,85% / IPCA + 0,85%',
  'IPCA_095': 'IPCA + 0,95% / IPCA + 0,95%',
  'IPCA_099': 'IPCA + 0,99% / IPCA + 0,99%',
  'IPCA_1': 'IPCA + 1,00%',
  'INCC_IPCA_1': 'INCC / IPCA + 1,00%',
  'FLEX_IPCA_1': 'FLEX IPCA / IPCA + 1,00%',
  'SAD_IPCA_099': '(SAD) IPCA + 0,99%'
}

// Mapeamento inverso: Descrição do plano -> Chave da API (gerado automaticamente de ALL_PLANOS)
export const PLANO_TO_API_KEY = Object.entries(ALL_PLANOS).reduce((acc, [key, value]) => {
  if (key !== '0') { 
    acc[value] = key;
  }
  return acc;
}, {});

// Mapeamento de FaixaComercial para o formato da API
export const FAIXA_TO_API = {
  'FAIXA1E5': 1,      // Faixa1e5
  'FAIXA2E3': 2,      // Faixa2e3
  'SBPE': 3,          // Sbpe
  'PROCOTISTA': 4,    // ProCotista
  'FAIXA3': 5,        // Faixa3
  'FAIXA4': 6,        // Faixa4
  'NA': 0             // NA
};

// Mapeamento de nomes do enum para valores numéricos - TipoPlanoFlex
export const TIPO_PLANO_FLEX_TO_VALUE = {
  'AVista': 1,
  'Fixo12': 2,
  'Fixo18': 3,
  'PrazoObra': 4,
  'PosObra': 5,
  'FinanciamentoBancario': 6,
  'NA': 0
};

// Mapeamento de nomes do enum para valores numéricos - TipoFluxo
export const TIPO_FLUXO_TO_VALUE = {
  'Cem_Zero': 1,
  'Vinte_Oitenta': 2,
  'Trinta_Setenta': 3,
  'Quarenta_Sessenta': 4,
  'Cinquenta_Cinquenta': 5,
  'NA': 0
};

// Mapeamento de nomes do enum para valores numéricos - TipoCorrecao
export const TIPO_CORRECAO_TO_VALUE = {
  'SemCorrecao': 1,
  'IPCA': 2,
  'IPCA_075': 3,
  'IPCA_085': 4,
  'IPCA_095': 5,
  'IPCA_099': 6,
  'IPCA_1': 7,
  'INCC_IPCA_1': 8,
  'FLEX_IPCA_1': 9,
  'SAD_IPCA_099': 10,
  'NA': 0
};

export const ProSolutoAMinimoParaCinquentaCinquenta = 13;